import { render, staticRenderFns } from "./Alibaba-assign.vue?vue&type=template&id=8f2d0042&scoped=true&"
import script from "./Alibaba-assign.vue?vue&type=script&lang=js&"
export * from "./Alibaba-assign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2d0042",
  null
  
)

export default component.exports